<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    [loading]="loading"
    [width]="isSimpleMode ? '8.96rem' : '7.5rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.title.addClient}}</h1>
        <n-help-link key="cifsAddUser" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifycifsManage" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-checkbox id="add-user-or-group-advance"
            *ngIf="ShardSwitch.CIFS_ADD_UNIX"
            class="ml-auto"
            [label]="i18n.label.advance"
            [(ngModel)]="advance"
            (onChange)="advanceChanged($event)">
        </n-checkbox>
    </n-header>

    <!-- 表单 -->
    <form [formGroup]="vm"
        [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [errorMessage]="errorMessage"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 用户类型 -->
        <n-form-item [label]="i18n.label.typeLabel"
            [required]="true">
            <n-select id="add-user-or-group-type"
                [options]="userTypeOpts"
                formControlName="userType">
            </n-select>
            <n-tip type="info"
                [class.hidden]="!showGuideTip || guideHide">
                <app-file-system-guide *ngIf="configGuide"
                    #guide
                    [vstoreId]="vstoreId"
                    [textConfigs]="configGuide.textConfigs"
                    [guideItems]="configGuide.guideItems"
                    (onEnd)="showGuideTip=$event">
                </app-file-system-guide>
            </n-tip>
        </n-form-item>
        <!-- 本地用户/用户组选择 -->
        <n-form-item *ngIf="isLocal"
            [labelHide]="true">
            <!-- 校验提示 -->
            <n-tip *ngIf="showErrorMsg"
                [type]="'failed'"
                [content]="i18n.error.atLeastSelectOneTip">
            </n-tip>
            <!-- 推拉表格 -->
            <n-transfer-table #transferTable
                id="add-user-table"
                [leftTitle]="i18n.label.leftTransferTitle"
                [rightTitle]="i18n.label.rightTransferTitle"
                [config]="tableConfig"
                [leftColumnDefs]="tableColumns"
                [rest]="localRest"
                [(selection)]="localSelection"
                (selectionChange)="onSelectionChange()">
            </n-transfer-table>
        </n-form-item>
        <!-- 域用户/用户组名称 -->
        <ng-container *ngIf="isDomain">
            <n-form-item [label]="i18n.label.name"
                required="true">
                <!-- 多项输入框 -->
                <n-multi-input id="add-client-cifs-share_domain_name"
                    formControlName="names"
                    [nTooltip]="domainToolTip"
                    [seperator]="[]"
                    [nTooltipTrigger]="'focus'"
                    [nTooltipPlacement]="'left'">
                </n-multi-input>
            </n-form-item>
        </ng-container>
        <n-form-item *ngIf="isLocal"
            labelHide="true">
            <button pButton
                [license]="[LicenseKey.NAS]"
                class="mt-10"
                style="display: block"
                [label]="i18n.btn.createBtn"
                (onClick)="onCreate()">
            </button>
        </n-form-item>
        <!-- 权限等级 -->
        <n-form-item [label]="i18n.label.permissionLevel" [required]="true">
            <n-select id="add-client-cifs-share_permission_dropdown"
                formControlName="permission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
    </form>

    <n-footer>
        <button id="select-user-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.btn.okBtn"
            (click)="done()">
        </button>
        <button id="select-user-cancel-btn"
            nButton
            [label]="i18n.btn.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
